import React from 'react';
import { useDispatch } from 'react-redux';
import MetricNumbers from '@components/overview-dashboard/common/metric-numbers/MetricNumbers';
import formatGaugeChartData, { spiColors } from '@utils/overview/gaugeChart';
import Chart from '@components/overview-dashboard/common/chart/Chart';
import { setSelectedKPI } from '@store/overviewDashboard/base/actions';
import { MetricNumbersTextWrapper, SPIChartScore } from './styled';
import Benchmark from './Benchmark';

export const getTextColor = (value: number) => {
  if (value < 60) {
    return spiColors.low;
  }
  if (value >= 60 && value < 80) {
    return spiColors.medium;
  }
  return spiColors.high;
};

const SPIMetricsText = ({ metricData, selectedMetric }) => {
  const dispatch = useDispatch();
  const metricValue = metricData[selectedMetric] ? metricData[selectedMetric].metricValue : '';

  const renderGauge = () => {
    const height = '120px';
    const width = '80px';
    const chartOption = formatGaugeChartData(metricValue.humanizedNumber);

    if (chartOption) {
      return <Chart option={chartOption} height={height} width={width} />;
    }
  };

  const onSPIClick = () => {
    dispatch(setSelectedKPI('StreamingPerformanceIndex'));
  };

  return (
    <MetricNumbersTextWrapper>
      <SPIChartScore onClick={onSPIClick} className="color-critical">
        {renderGauge()}
        <MetricNumbers metricValue={{ humanizedNumber: metricValue.humanizedNumber, humanizedUnit: '' }} textColor={getTextColor(metricValue.humanizedNumber)} />
      </SPIChartScore>
      <Benchmark />
    </MetricNumbersTextWrapper>
  );
};

export default SPIMetricsText;
